import { useState } from "react"
import "../assets/styles/component.css"
import { AdviseLabels } from "../enums/MessageEnum"
import FormInput from "../elements/FormInput"
import ServiceModal from "../elements/ServiceModal"
import axios from "axios"

export default function ContactUs(props){

    const defaultFormData = {
        nombre: "",
        apellido: "",
        correo: "",
        nombreEmpresa: "",
        descripcion: ""
    }

    const defaultFormValidationData = {
        nombre: false,
        apellido: false,
        correo: false,
        nombreEmpresa: false,
        descripcion: false
    }

    const [formData, setFormData] = useState(defaultFormData)
    const [formDataValidation, setFormDataValidation] = useState(defaultFormValidationData)

    function handleValidation(name, value){
        let valid = false;
        if (name === 'correo'){
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            valid = regex.test(value);
        }
        else{
            valid = value.length > 0
        }
        setFormDataValidation({
            ...formDataValidation,
            [name]: valid
        })
    }

    const handleInputChange = (e) => {
        handleValidation(e.target.name, e.target.value)
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    } 

    function isFormValid() {
        for (let key in formDataValidation) {
            if (!formDataValidation[key]) {
                return false;
            }
        }
        return true;
    }

    function handleSubmit(){
        const isValidForm = isFormValid()
        setShowError(!isValidForm)
        setShowModal(isValidForm)
        if (isValidForm){
            axios.post(process.env.REACT_APP_URL_BACKEND + "/correo", formData)
            setFormData(defaultFormData)
            setFormDataValidation(defaultFormValidationData)
        }
    }

    const [showModal, setShowModal] = useState(false)
    const [showError, setShowError] = useState(false)

    return(
        <div id="contact-us">
            <div className="contact-container"> 
                <div className="contact-message-container bg-advise-color"
                     style={{height: props.isLargeScreen ? "80vh" : ""}}>
                    <h2 className="text-4xl text-white contact-title">{AdviseLabels.CONTACT_SUBTILTE}</h2>
                    <p className="text-xl text-white text-justify contact-text">{AdviseLabels.CONTACT_DESCRIPTION}</p>
                </div>
                <div className="contact-form-container">
                    <div className="contact-name-form-container">
                        <FormInput inputname="Nombre"
                                  type="text" name="nombre" value={formData.nombre}
                                  setValue={handleInputChange} showError={showError}
                                  validation={formDataValidation.nombre}/>
                        <FormInput inputname="Apellido"
                                  type="text" name="apellido" value={formData.apellido}
                                  setValue={handleInputChange} showError={showError}
                                  validation={formDataValidation.apellido}/>
                    </div>
                    <FormInput inputname="Correo"
                                  type="email" name="correo" value={formData.correo}
                                  setValue={handleInputChange} showError={showError}
                                  validation={formDataValidation.correo}/>
                    <FormInput inputname="Empresa"
                                  type="text" name="nombreEmpresa" value={formData.nombreEmpresa}
                                  setValue={handleInputChange} showError={showError}
                                  validation={formDataValidation.nombreEmpresa}/>
                    <FormInput inputname="Mensaje"
                                  type="textarea" name="descripcion" value={formData.descripcion}
                                  setValue={handleInputChange} showError={showError}
                                  validation={formDataValidation.descripcion}/>
                    <div className="button-container-send">
                        <button className="bg-advise-color hover:bg-blue-400 text-white text-xl 
                                            font-bold py-3 px-16 rounded
                                            transition duration-300 ease-in-out product-info-button"
                                onClick={handleSubmit}>
                            Enviar
                        </button>
                    </div>  
                </div>  
            </div>
            <ServiceModal showModal={showModal} setShowModal={setShowModal} 
            title={AdviseLabels.CONTACT_SEND_TITLE} 
            description={AdviseLabels.CONTACT_SEND_MESSAGE}/>
        </div>
    )
}